import { ArrayOps } from '../lift';
/**
 * Reverses the Array.
 */
export function reverse() {
    return new ArrayOps(this.value().slice().reverse());
}
ArrayOps.prototype.reverse = reverse;
